const initialState = {
  "activeSession": null,
  "findingGame": false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "FIND_GAME_SESSION":
      return { ...state, findingGame: true };
    case "END_GAME_SESSION":
      return { ...state, "activeSession": null };
    case "GAME_FOUND":
      var activeSession = action.payload;
      var users = activeSession.users;
      users.sort(function (a, b) {
        return (b.score - a.score)
      });
      activeSession.users = users;
      return { ...state, activeSession: activeSession, findingGame: false };
    default:
      return state;
  }
};
